import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { PipesModule } from '@shared/modules/pipes/pipes.module';
import { FooterComponent } from './footer.component';

@NgModule({
  declarations: [FooterComponent],
  imports: [CommonModule, MatButtonModule, RouterModule, PipesModule],
  exports: [FooterComponent],
})
export class FooterModule {}
